export default __webpack_public_path__ + "static/media/product-7.2dfe8ff5.png";